import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  Grid,
  Chip,
  DialogContent,
  Tooltip,
  DialogActions,
  Divider,
  Button,
  CircularProgress,
  IconButton,
  useTheme,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { DashedPaper } from "../StyledComponents";
import { trackLesson, BackButton, escapeLatexInJson } from "./functions";
import { useSnackbar } from "./SnackbarHandler";
import EditIcon from "@mui/icons-material/Edit";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { MathJaxContext, MathJax } from "better-react-mathjax";
import { callApi } from "./api";
import MoreToCome from "./MoreToCome";
import CodeOverlay from "./CodeOverlay";

import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useNavigate } from "react-router-dom";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import TimelineIcon from "@mui/icons-material/Timeline";
import Logger from "./Logger";
import ShareIcon from "@mui/icons-material/Share";

import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import QuizDifficultyDialog from "./QuizDifficultyDialog";
import SaveIcon from "@mui/icons-material/SaveAs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import KeyIcon from "@mui/icons-material/Key";
import GenerateIcon from "@mui/icons-material/AutoAwesome";
import Translate from "./Translate";
import { Link } from "react-router-dom";
import { createUrlSlug } from "./functions";
import AutoFixHigh from "@mui/icons-material/AutoFixHigh";

import AutorenewIcon from "@mui/icons-material/Autorenew"; // Using Autorenew as Generate icon
import SaveAsIcon from "@mui/icons-material/SaveAs";
import AddIcon from "@mui/icons-material/Add";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import PeopleIcon from "@mui/icons-material/People";
import SchoolIcon from "@mui/icons-material/School";

import {
  collection,
  getDocs,
  query,
  where,
  documentId,
  deleteDoc,
  addDoc,
  updateDoc,
  doc,
  limit,
} from "firebase/firestore";
import { db } from "./firebase";

import QuestionDisplay from "./QuestionDisplay";

// hej
const TeacherQuizDisplay = ({
  quiz,
  quizId,
  quizName,
  questionType,
  onPrint,
  onQuizUpdate = () => {},
  onNameChange,
  styles,
  onShare,
  onShareWithFriends,
  onSave,
  onClose,
  editMode = false,
  user,
  category,
  difficulty,
  aiInstructions,
  selectedLanguage,
  selectedModel,
  addQuizToLessonObject,
  selectedQuiz,
  reloadMyQuizzes,
  includeTimer,
  duration,
  lessonData,
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [quizData, setQuizData] = useState(quiz);
  const [isAnimating, setIsAnimating] = useState(false);
  const [difficultyDialogOpen, setDifficultyDialogOpen] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [showCodeOverlay, setShowCodeOverlay] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [shareAnchorEl, setShareAnchorEl] = useState(null);

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleShareMenuClose = () => {
    setShareAnchorEl(null);
  };

  const translateButtonRef = useRef(null);
  const [localQuizName, setLocalQuizName] = useState(quizName);
  const commonTags = [
    "Matematik",
    "Svenska",
    "Engelska",
    "Samhällskunskap",
    "Naturkunskap",
    "Kemi",
    "Fysik",
    "Biologi",
    "Historia",
    "Religion",
    "Geografi",

    "Teknik",
    "Bild",
    "Musik",
    "Slöjd",
    "Modersmål",
    "Moderna språk",
    "Språk",
    "Idrott och hälsa",
    "Spanska",
    "Tyska",
    "Franska",
    "Hem- och konsumentkunskap",
    "Företagsekonomi",
    "Psykologi",
    "Filosofi",
    "1-3",
    "4-6",
    "7-9",
    "Gymnasiet",
    "Nationella provet",
    "Påsk",
    "Alla hjärtans dag",
  ];

  const [tags, setTags] = useState(selectedQuiz?.tags || []);

  const [tagInput, setTagInput] = useState("");

  Logger.log("addQuizToLessonObject: ", addQuizToLessonObject);

  //

  const [aiQuestionDialogOpen, setAiQuestionDialogOpen] = useState(false);
  const [aiQuestionPrompt, setAiQuestionPrompt] = useState("");
  const [isGeneratingQuestion, setIsGeneratingQuestion] = useState(false);

  // 2. Add this function to handle generating a new question with AI
  // Modify the handleAddQuestionWithAI function in TeacherQuizDisplay
  const handleAddQuestionWithAI = async () => {
    // Close the dialog first
    handleCloseAiQuestionDialog();

    // Add a dummy question to show the loading state
    const defaultQuestion = getDefaultQuestion(questionType);
    const dummyQuestion = {
      ...defaultQuestion,
      question: "Genererar fråga med AI...", // Placeholder text
      isGenerating: true, // Flag to indicate this is a generating question
    };

    // Add the dummy question to the quiz
    const newQuizDataWithDummy = [...quizData, dummyQuestion];
    setQuizData(newQuizDataWithDummy);
    onQuizUpdate(newQuizDataWithDummy);

    // Scroll to the new question
    setTimeout(() => {
      const questions = document.querySelectorAll(".question-card");
      const lastQuestion = questions[questions.length - 1];
      lastQuestion?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);

    try {
      // Create a default question structure as template
      const defaultQuestion = getDefaultQuestion(questionType);

      // Om quizet blir för stort, kan du begränsa antalet frågor som skickas
      const questionsForContext =
        quizData.length > 5
          ? quizData.slice(-5) // Bara de senaste 5 frågorna
          : quizData; // Hela quizet om mindre än 5 frågor

      // Prepare the message for the API
      const messages = [
        {
          role: "system",
          content: `Du är en expert på att skapa pedagogiska quiz-frågor. Du ska skapa en ny fråga i det angivna formatet baserat på instruktionerna. Svara ENDAST med ett giltigt JSON-objekt.


Om det är matematik-frågor: När du använder LaTeX-syntax MÅSTE du omsluta VARJE matematiskt uttryck (oavsett om det är enkla operationer eller komplexa ekvationer) med dollartecken på följande sätt:

För uttryck inom textrader: $x \times y$
För fristående uttryck: $$x \times y$$

Använd ALDRIG [], () eller andra tecken runt matematiska uttryck. ALLTID dollartecken.


          `,
        },
        {
          role: "user",
          content: `Här är alla befintliga frågor i quizet:\n\n${JSON.stringify(questionsForContext, null, 2)}\n\nSkapa en ny quiz-fråga i samma JSON-format som de befintliga frågorna. ${questionType === "true-or-false" ? "Alltså två svarsalternativ som antingen är sant eller falskt." : ""}. Följande instruktion beskriver vad frågan ska handla om: ${aiQuestionPrompt ? aiQuestionPrompt : "Lägg till en fråga som kompletterar de andra frågorna bra."}. \n\nFrågan ska vara på ${selectedLanguage} och bör INTE vara för lik någon av de befintliga frågorna. Försök att täcka andra aspekter eller områden inom samma tema. Slumpa vilken placering det rätta svaret har för att undvika mönster där det första alternativet alltid är korrekt. Returnera endast det nya JSON-objektet med samma struktur som de befintliga frågorna.`,
        },
      ];

      Logger.log("BEFOE: ", JSON.stringify(questionsForContext, null, 2));

      // Call the API
      const response = await callApi(messages, 2000, true, user.uid);

      // Extract the response content
      const messageContent = response.data.choices[0].message.content.trim();

      // Parse the JSON from the response
      let parsedResponse;
      try {
        // Extract JSON if it's wrapped in code blocks
        let jsonContent = messageContent;
        if (jsonContent.startsWith("```json")) {
          jsonContent = jsonContent.slice(7, -3).trim();
        } else if (jsonContent.startsWith("```")) {
          jsonContent = jsonContent.slice(3, -3).trim();
        }
        jsonContent = escapeLatexInJson(jsonContent);

        parsedResponse = JSON.parse(jsonContent);

        // Replace the dummy question with the real one
        const newQuizData = [
          ...quizData.filter((q) => !q.isGenerating),
          parsedResponse,
        ];

        await trackLesson(user.uid, "QuizViewNewQuestion.js", null, null);
        setQuizData(newQuizData);
        onQuizUpdate(newQuizData);
        setHasUnsavedChanges(true);
      } catch (parseError) {
        console.error("Error parsing JSON response:", parseError);
        showSnackbar("Det gick inte att skapa frågan. Försök igen.", "error");

        // Remove the dummy question if there was an error
        const newQuizData = quizData.filter((q) => !q.isGenerating);
        setQuizData(newQuizData);
        onQuizUpdate(newQuizData);
      }
    } catch (error) {
      console.error("Error generating question:", error);
      showSnackbar("Det gick inte att skapa frågan. Försök igen.", "error");

      // Remove the dummy question if there was an error
      const newQuizData = quizData.filter((q) => !q.isGenerating);
      setQuizData(newQuizData);
      onQuizUpdate(newQuizData);
    }
  };

  // 3. Add these handler functions for the dialog
  const handleOpenAiQuestionDialog = () => {
    setAiQuestionDialogOpen(true);
  };

  const handleCloseAiQuestionDialog = () => {
    setAiQuestionDialogOpen(false);
    setAiQuestionPrompt("");
  };

  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [isSavingWithoutInteractiveMode, setIsSavingWithoutInteractiveMode] =
    useState(false);

  useEffect(() => {
    if (selectedQuiz?.tags) {
      setTags(selectedQuiz.tags);
    }
  }, [selectedQuiz]);
  const handleAnimateEditAndDeleteIcon = () => {
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 2000);
  };

  const handleDifficultyUpdate = (newQuizData) => {
    setQuizData(newQuizData);
    onQuizUpdate(newQuizData);
    setHasUnsavedChanges(true);
  };

  const getDefaultQuestion = (type) => {
    if (type === "exam") {
      return {
        question: "",
        type: "exam",
      };
    }
    return {
      question: "",
      options: ["", "", "", ""],
      correct: "",
    };
  };

  const handleAddQuestionAndScroll = () => {
    const newQuizData = [...quizData, getDefaultQuestion(questionType)];
    setQuizData(newQuizData);
    onQuizUpdate(newQuizData);

    setTimeout(() => {
      const questions = document.querySelectorAll(".question-card");
      const lastQuestion = questions[questions.length - 1];
      lastQuestion?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  const handleQuizNavigation = async () => {
    if (!quizId) {
      // If no quizId exists, we need to save first
      setIsSaving(true);
      try {
        const docRef = await addDoc(collection(db, "quiz"), {
          userId: user.uid,
          results: quizData,
          quizName: localQuizName,
          createdAt: Date.now(),
          byAdmin: "No",
          isPublic: true,
          questionType: questionType,
          category,
          difficulty,
          aiInstructions,
          lastTrainingSession: Date.now(),
          language: selectedLanguage,
          aiModel: selectedModel,
          upvotes: 0,
          downvotes: 0,
          userVotes: {},
          includeTimer: includeTimer,
          duration: duration,
        });

        // Navigate to the new quiz using the newly created ID
        const formattedQuizName = createUrlSlug(localQuizName);
        navigate(`/app/quiz/${docRef.id}/${formattedQuizName}`);
      } catch (error) {
        console.error("Error saving quiz:", error);
        showSnackbar("Ett fel uppstod när quizzet skulle sparas.", "error");
      } finally {
        setIsSaving(false);
      }
    } else {
      // If quizId exists, navigate directly
      navigate(`/app/quiz/${quizId}/${createUrlSlug(localQuizName)}`);
    }
  };
  const handleSave = async () => {
    try {
      setIsSavingWithoutInteractiveMode(true);

      // If viewing someone else's quiz, always create new
      if (selectedQuiz?.userId !== user.uid) {
        const newQuizData = {
          userId: user.uid,
          quizName: `${localQuizName} (Kopia)`,
          results: quizData,
          createdAt: Date.now(),
          byAdmin: "No",
          isPublic: true,
          questionType: selectedQuiz.questionType,
          category: selectedQuiz.category,

          difficulty: selectedQuiz.difficulty,
          aiInstructions: selectedQuiz.aiInstructions,

          lastTrainingSession: null,
          language: selectedQuiz.language,
          aiModel: selectedQuiz.aiModel,

          tags: tags || [],
          includeTimer: false, // Set a default value
          duration: duration || 0, // Set a default value
        };

        await addDoc(collection(db, "quiz"), newQuizData);
        showSnackbar("Quiz kopierat och sparat i 'Mina quiz'", "success");
        handleClose();
      } else {
        // Update user's own quiz
        const quizRef = doc(db, "quiz", quizId);

        if (quizId === "61xQiydVKa9KCBCQsIkp") {
          showSnackbar("Sparat!", "success");
          return;
        }

        await updateDoc(quizRef, {
          results: quizData,
          quizName: localQuizName,
          updatedAt: Date.now(),
          tags: tags,
          includeTimer: includeTimer || false,
          duration: duration || 0,
        });
        showSnackbar("Quizzet har uppdaterats!", "success");
      }

      if (typeof reloadMyQuizzes === "function") {
        reloadMyQuizzes();
      }
    } catch (error) {
      console.error("Error saving quiz:", error);
      showSnackbar("Ett fel uppstod när quizzet skulle sparas.", "error");
    } finally {
      setIsSavingWithoutInteractiveMode(false);
    }
  };

  const handleShare = () => {
    //handleClose();
    onShare();
  };

  const handleShareWithFriends = () => {
    //handleClose();
    onShareWithFriends();
  };

  const handleUpdateQuestion = (index, updatedQuestion) => {
    const newQuizData = [...quizData];
    newQuizData[index] = updatedQuestion;
    setQuizData(newQuizData);
    onQuizUpdate(newQuizData);
    setHasUnsavedChanges(true);
  };

  const handleDeleteQuestion = (index) => {
    const newQuizData = quizData.filter((_, idx) => idx !== index);
    setQuizData(newQuizData);
    onQuizUpdate(newQuizData);
  };

  const handleAddQuestion = () => {
    const newQuizData = [...quizData, getDefaultQuestion(questionType)];
    setQuizData(newQuizData);
    onQuizUpdate(newQuizData);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        fullWidth
        scroll="paper"
        PaperProps={{
          sx: {
            width: "94vw",
            height: "94vh",
            maxWidth: "1800px",
            maxHeight: "1000px",
            margin: "auto",
            borderRadius: "10px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            backgroundColor:
              theme.palette.mode === "dark" ? "#22303C" : "white",
            backgroundImage: theme.palette.mode === "dark" ? "none" : "white",
            padding: { xs: "12px", md: "24px" },
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 0,
            pt: 0,

            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 2, right: 2 }}
            onClick={handleClose}
          >
            <CloseIcon sx={{ fontSize: "1.5rem" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background:
                theme.palette.mode === "dark"
                  ? "rgba(255, 255, 255, 0.05)" // Lighter default for dark mode
                  : "rgb(0 0 0 / 34%) transparent", // Lighter default for light mode
              borderRadius: "4px",
              "&:hover": {
                background:
                  theme.palette.mode === "dark"
                    ? "rgba(255, 255, 255, 0.1)" // Previous default color now on hover
                    : "rgba(0, 0, 0, 0.06)", // Previous default color now on hover
              },
            },
          }}
        >
          {quizId === "61xQiydVKa9KCBCQsIkp" && (
            <Typography
              variant="h2"
              sx={{ fontSize: "1.1rem", fontWeight: 500 }}
            >
              Demo-quiz (Redigeringsläge)
            </Typography>
          )}

          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Tooltip title="Förstora provnyckeln" placement="top">
              <Chip
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowCodeOverlay(quizId.substring(0, 6));
                }}
                label={
                  <Box
                    sx={{
                      display: "flex",

                      alignItems: "center",
                      gap: 0.5,
                      pointerEvents: "auto !important",
                    }}
                  >
                    <KeyIcon sx={{ fontSize: 25, mr: 1 }} />
                    Kod till elever (inget konto krävs)
                  </Box>
                }
                size="small"
                sx={{
                  ...styles.greenChip,
                  height: "50px",
                  cursor: "pointer",
                  mb: 2,
                  fontSize: "1.2rem",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  pointerEvents: "auto !important",
                  "&:hover": {
                    backgroundColor: `${theme.palette.primary.main} !important`,
                    color: "white !important",
                  },
                  display: "none",
                }}
              />
            </Tooltip>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              flexDirection: {
                xs: "column",
                md: "row",
              },
            }}
          >
            <Box sx={{ flex: "1 1 auto" }}>
              <Grid container spacing={3} sx={{ width: "100%" }}>
                {quizData.map((question, index) => (
                  <QuestionDisplay
                    key={index}
                    question={question}
                    index={index}
                    type={questionType}
                    onUpdateQuestion={handleUpdateQuestion}
                    onDeleteQuestion={handleDeleteQuestion}
                    styles={styles}
                    className="question-card"
                    isAnimating={isAnimating}
                    user={user} // Pass user for API authentication
                    selectedLanguage={selectedLanguage} // Pass language for regeneration
                    selectedModel={selectedModel} // Pass model for regeneration
                    showSnackbar={showSnackbar}
                    questionType={questionType}
                  />
                ))}

                <Grid item xs={12} md={6}>
                  <Grid container rowSpacing={4} sx={{ width: "100%" }}>
                    <Grid item xs={12} md={12}>
                      <DashedPaper
                        onClick={handleOpenAiQuestionDialog}
                        sx={{ minHeight: 200 }}
                      >
                        <Box sx={{ textAlign: "center" }}>
                          <AutoFixHigh
                            sx={{
                              fontSize: 48,
                              color: theme.palette.primary.main,
                              mb: 2,
                            }}
                          />
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Lägg till fråga med AI
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 1 }}
                          >
                            Låt AI skapa en ny fråga
                          </Typography>
                        </Box>
                      </DashedPaper>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <DashedPaper
                        onClick={handleAddQuestion}
                        sx={{ minHeight: 200 }}
                      >
                        <Box sx={{ textAlign: "center" }}>
                          <AddIcon
                            sx={{
                              fontSize: 48,
                              color: theme.palette.primary.main,
                              mb: 2,
                            }}
                          />
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Lägg till fråga manuellt
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 1 }}
                          >
                            Skriv frågan och svaren själv
                          </Typography>
                        </Box>
                      </DashedPaper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Box
                sx={{ display: "flex", justifyContent: "center", mb: 4, mt: 4 }}
              >
                <Button
                  variant="print"
                  startIcon={<AddIcon />}
                  onClick={handleAddQuestion}
                  sx={{ display: "none" }}
                >
                  Lägg till ny fråga
                </Button>
              </Box>
              <MathJaxContext
                config={{
                  tex: {
                    inlineMath: [
                      ["$", "$"],
                      ["\\(", "\\)"],
                    ],
                    displayMath: [
                      ["$$", "$$"],
                      ["\\[", "\\]"],
                    ],
                  },
                  chtml: {
                    scale: 1.1, // Global scaling factor
                    fontFamily: "Arial", // Font to use
                    matchFontHeight: false, // Match surrounding font height
                    displayAlign: "left", // How to align displayed equations
                    displayIndent: "0", // Indent for displayed equations
                  },
                }}
              >
                <Card
                  elevation={0}
                  sx={{
                    mt: 10,
                    backgroundColor: theme.palette.background.paperHover,
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: "15px",
                    padding: "20px",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: "600" }}
                    >
                      Facit
                    </Typography>
                    {quizData.map((question, index) => (
                      <Box key={index} sx={{ mb: 2, mt: 4 }}>
                        <Typography>
                          <MathJax>
                            {" "}
                            Fråga {index + 1}: {question.correct}{" "}
                          </MathJax>
                        </Typography>
                      </Box>
                    ))}
                  </CardContent>
                </Card>
              </MathJaxContext>
              <Card
                elevation={0}
                sx={{
                  mt: 10,
                  backgroundColor: theme.palette.background.paperHover,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: "15px",
                  padding: "20px",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: "600", mb: 3 }}
                  >
                    Namn på quiz
                  </Typography>
                  {editMode ? (
                    <TextField
                      value={localQuizName}
                      onChange={(e) => setLocalQuizName(e.target.value)}
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        fontWeight: "700",
                        margin: "0 auto",
                        "& .MuiInputBase-root": {
                          ...styles.editingTextField["& .MuiInputBase-root"],
                        },
                      }}
                      InputProps={{
                        style: {
                          fontWeight: "500",
                          fontSize: "1.05rem",
                        },
                      }}
                    />
                  ) : (
                    <Typography variant="h6" sx={{ fontWeight: "600" }}>
                      {localQuizName}
                    </Typography>
                  )}
                </CardContent>
              </Card>
              <Card
                elevation={0}
                sx={{
                  mt: 10,
                  backgroundColor: theme.palette.background.paperHover,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: "15px",
                  padding: "20px",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: "600", mb: 2 }}
                  >
                    Taggar (valfritt):
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1, display: "none" }}
                    >
                      Vanliga taggar:
                    </Typography>
                    <Box
                      sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}
                    >
                      {commonTags.map((tag) => (
                        <Button
                          key={tag}
                          variant={
                            tag === "1-3" ||
                            tag === "4-6" ||
                            tag === "7-9" ||
                            tag === "Gymnasiet"
                              ? "success"
                              : tag === "Nationella provet"
                                ? "purp"
                                : "print"
                          }
                          startIcon={
                            tags.includes(tag) ? (
                              <CheckCircleIcon sx={{ color: "green" }} />
                            ) : (
                              ""
                            )
                          }
                          onClick={() => {
                            if (tags.includes(tag)) {
                              setTags(tags.filter((t) => t !== tag));
                            } else {
                              setTags([...tags, tag]);
                            }
                          }}
                          sx={{
                            ...styles.tightButton,
                          }}
                        >
                          {tag}
                        </Button>
                      ))}
                    </Box>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <TextField
                      fullWidth
                      value={tagInput}
                      onChange={(e) => setTagInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && tagInput.trim()) {
                          setTags([...new Set([...tags, tagInput.trim()])]);
                          setTagInput("");
                        }
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          ...styles.editingTextField["& .MuiInputBase-root"],
                        },
                      }}
                      placeholder="Skriv och tryck enter för att lägga till tagg"
                      variant="outlined"
                    />
                    <Box
                      sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 1 }}
                    >
                      {tags.map((tag) => (
                        <Chip
                          key={tag}
                          label={tag}
                          onDelete={() =>
                            setTags(tags.filter((t) => t !== tag))
                          }
                          sx={{ m: 0.5 }}
                        />
                      ))}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Box sx={{ position: "relative" }}>
              <Box
                sx={{
                  ...styles.lessonControlPanel,
                  ...styles.lessonControlPanelNuevo2,
                  paddingRight: 2,
                  "& .MuiButton-root": {
                    ...styles.controlPanelButtons,
                    ...styles.lessonControlPanelNewButtons2,
                  },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                  }}
                >
                  Addera
                </Typography>

                <Button
                  variant="success"
                  startIcon={<AutoFixHigh />}
                  onClick={handleOpenAiQuestionDialog}
                >
                  Låt AI skapa fråga
                </Button>

                <Button
                  variant="print"
                  startIcon={<AddIcon />}
                  onClick={handleAddQuestionAndScroll}
                >
                  Skriv fråga själv
                </Button>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    mt: 3,
                  }}
                >
                  Hantera
                </Typography>

                <Button
                  variant="print"
                  onClick={() => setDifficultyDialogOpen(true)}
                  sx={{ mr: 2 }}
                  startIcon={<AutoFixHighIcon />}
                >
                  Ändra svårighetsgrad
                </Button>
                <Translate
                  buttonRef={translateButtonRef}
                  lessonData={quizData}
                  onTranslated={setQuizData}
                  callApi={callApi}
                  user={user}
                  showSnackbar={showSnackbar}
                  disabled={true}
                />
                <Button
                  variant="print"
                  startIcon={<EditIcon />}
                  sx={{ ml: 2 }}
                  onClick={handleAnimateEditAndDeleteIcon}
                  sx={{ display: "none !important" }}
                >
                  Redigera quiz
                </Button>

                {addQuizToLessonObject && (
                  <Button
                    variant="success"
                    onClick={async () => {
                      Logger.log("lessonData: ", lessonData);
                      // First add to the lesson object and save to "Mina Quiz" in one operation
                      await addDoc(collection(db, "quiz"), {
                        userId: user.uid,
                        results: quizData,
                        quizName: lessonData.title || localQuizName,
                        createdAt: Date.now(),
                        byAdmin: "No",
                        isPublic: true,
                        questionType: questionType,
                        category: category || null,
                        difficulty: difficulty || null,
                        aiInstructions: aiInstructions || null,

                        lastTrainingSession: Date.now(),
                        language: selectedLanguage || null,
                        aiModel: selectedModel || null,
                        upvotes: 0,
                        downvotes: 0,
                        userVotes: {},
                        tags: tags || [],
                        includeTimer: includeTimer || false,
                        duration: duration || 0,
                      })
                        .then((docRef) => {
                          // Now we have the quizId from the newly created document
                          // Add it to the lesson object along with the quiz data
                          addQuizToLessonObject((prevLessonData) => ({
                            ...prevLessonData,
                            quiz: quizData, // Keep the original array of questions
                            quizId: docRef.id, // Add the ID as a separate property
                          }));

                          // Close dialog after both operations
                          handleClose();
                        })
                        .catch((error) => {
                          console.error("Error saving quiz:", error);
                          showSnackbar(
                            "Ett fel uppstod när quizzet skulle sparas.",
                            "error",
                          );
                        });
                    }}
                    sx={{ mr: 2, ml: 2, color: "green !important" }}
                    startIcon={<GenerateIcon sx={{ color: "green" }} />}
                  >
                    Lägg till quiz i din lektion
                  </Button>
                )}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    mt: 3,
                  }}
                >
                  Spara
                </Typography>

                {!addQuizToLessonObject && (
                  <>
                    <Tooltip
                      title={
                        editMode
                          ? ""
                          : "Spara ditt quiz om du vill redigera det vid senare tillfälle, eller dela med fler elever vid senare tidpunkt."
                      }
                    >
                      <Button
                        variant={editMode ? "print" : "print"}
                        onClick={handleSave}
                        sx={{
                          mr: 2,
                          animation: hasUnsavedChanges ? "pulse 1s " : "none",
                          "@keyframes pulse": {
                            "0%": { transform: "scale(1)" },
                            "50%": { transform: "scale(1.05)" },
                            "100%": { transform: "scale(1)" },
                          },
                        }}
                        disabled={isSavingWithoutInteractiveMode}
                        startIcon={
                          isSavingWithoutInteractiveMode ? (
                            <CircularProgress size={18} />
                          ) : (
                            <SaveAsIcon />
                          )
                        }
                      >
                        {!selectedQuiz
                          ? "Spara"
                          : selectedQuiz.userId !== user.uid
                            ? "Spara till 'Mina Quiz'"
                            : editMode
                              ? "Spara ändringar"
                              : "Spara"}
                      </Button>
                    </Tooltip>
                    <Button
                      variant="purp"
                      onClick={() => onPrint(quizData)}
                      startIcon={<PrintIcon />}
                    >
                      Skriv ut
                    </Button>

                    {questionType !== "current-events" && (
                      <>
                        {user.accountType === "student" && (
                          <Tooltip title="Starta ett interaktivt quiz!">
                            <Button
                              variant="purp"
                              onClick={handleQuizNavigation}
                              sx={{ mr: 2 }}
                              disabled={isSaving}
                              startIcon={
                                isSaving ? (
                                  <CircularProgress
                                    size={18}
                                    sx={{ color: "white" }}
                                  />
                                ) : (
                                  <PlayArrowIcon />
                                )
                              }
                            >
                              {isSaving ? "Startar quiz..." : "Quizza mig"}
                            </Button>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </>
                )}

                {user.accountType === "teacher" && (
                  <>
                    {questionType !== "current-events" && (
                      <>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: "text.secondary",
                            mt: 3,
                          }}
                        >
                          Visa
                        </Typography>

                        <Tooltip
                          title="Hur quizet ser ut för eleverna (ny flik)"
                          placement="top"
                        >
                          <Button
                            variant="purp"
                            onClick={() => {
                              window.open(
                                `/app/quiz/${quizId}/${quizName}`,
                                "_blank",
                              );
                            }}
                            startIcon={<PersonOutlineIcon />}
                          >
                            Elevläge
                          </Button>
                        </Tooltip>

                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: "text.secondary",
                            mt: 3,
                          }}
                        >
                          Dela
                        </Typography>
                        {/* Button to share via quiz key */}
                        <Button
                          variant="purp"
                          onClick={() =>
                            setShowCodeOverlay(quizId.substring(0, 6))
                          }
                          sx={{ mr: 2, mb: 2 }}
                          startIcon={<KeyIcon />}
                        >
                          Dela via provnyckel
                        </Button>
                        {/* Button to share with students */}
                        {onShare && (
                          <Button
                            variant="purp"
                            onClick={() => handleShare()}
                            sx={{ mr: 2, mb: 2 }}
                            startIcon={<ShareIcon />}
                          >
                            Dela med elever
                          </Button>
                        )}

                        {/* Button to share with friends */}
                        {onShareWithFriends && (
                          <Button
                            variant="purp"
                            onClick={() => handleShareWithFriends()}
                            sx={{ mr: 2, mb: 2 }}
                            startIcon={<PeopleIcon />}
                          >
                            Dela med vänner
                          </Button>
                        )}

                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontWeight: 600,
                            color: "text.secondary",
                            mt: 3,
                          }}
                        >
                          Övervaka resultat
                        </Typography>
                        <Button
                          variant="purp"
                          onClick={() => {
                            navigate(`/app/resultat/${quizId}`);
                          }}
                          sx={{ mr: 2, mb: 2 }}
                          startIcon={<TimelineIcon />}
                        >
                          Övervaka resultat
                        </Button>
                      </>
                    )}
                  </>
                )}

                <Box>
                  <MoreToCome user={user} />
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <QuizDifficultyDialog
          open={difficultyDialogOpen}
          onClose={() => setDifficultyDialogOpen(false)}
          quiz={quizData}
          onUpdateQuiz={handleDifficultyUpdate}
          showSnackbar={showSnackbar}
          theme={theme}
        />
        {showCodeOverlay && (
          <CodeOverlay
            code={showCodeOverlay}
            quizId={quizId}
            onClose={() => setShowCodeOverlay(null)}
          />
        )}
      </Dialog>
      <Dialog
        open={aiQuestionDialogOpen}
        onClose={handleCloseAiQuestionDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontWeight: 600 }}>
          Skapa fråga med AI
          <IconButton
            aria-label="close"
            onClick={handleCloseAiQuestionDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2, mt: 2 }}>
            Beskriv vad den nya frågan ska handla om (valfritt):
          </Typography>
          <TextField
            autoFocus
            fullWidth
            multiline
            autoFocus
            rows={3}
            placeholder="T.ex. 'Skapa en matte-fråga om Pythagoras sats', 'Gör en fråga om Sveriges riksdag', 'Skapa en grammatikfråga'"
            value={aiQuestionPrompt}
            onChange={(e) => setAiQuestionPrompt(e.target.value)}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAddQuestionWithAI}
            variant="purp"
            disabled={isGeneratingQuestion}
            startIcon={
              isGeneratingQuestion ? (
                <CircularProgress sx={{ color: "white" }} size={16} />
              ) : (
                <AutoFixHighIcon />
              )
            }
          >
            {isGeneratingQuestion ? "Skapar fråga..." : "Generera fråga"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TeacherQuizDisplay;
